import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var MediaTypes = t.keyof({
  image: null,
  video: null,
  file: null
});
export var UploadedFile = t.intersection([t.type({
  url: t.string,
  filename: t.string,
  handle: t.string,
  mimetype: t.string
}), t.partial({
  mediaType: MediaTypes,
  key: t.string
})]);
export var UploadedFileFromUrl = t.intersection([UploadedFile, t.type({
  container: t.string,
  size: t.number,
  type: t.string
})]);
export var ImageInput = t.intersection([t.type({
  url: t.string
}), t.partial({
  filestack: nullable(t.type({
    handle: t.string
  }))
})]);